import { Controller } from "@hotwired/stimulus"

export default class BulkGeocodeMonitorController extends Controller {
  static targets = [
    "statusBadge", "progressBar", "currentStep",
    "stepText", "zipsCount", "citiesCount", "msasCount",
    "elapsedText", "etaText", "errorBlock", "errorText"
  ]
  static values = { url: String, active: Boolean }

  connect() {
    if (this.activeValue) this.poll()
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  poll() {
    fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(data => this.update(data))
      .catch(() => {})
      .finally(() => {
        if (this.activeValue) {
          this._timer = setTimeout(() => this.poll(), 2000)
        }
      })
  }

  update(data) {
    if (data.status === "none") return

    if (this.hasStatusBadgeTarget) {
      this.statusBadgeTarget.textContent = this.capitalize(data.status)
      this.statusBadgeTarget.className = `status-badge status-${data.status}`
    }

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${data.progress_percentage}%`
    }

    if (this.hasCurrentStepTarget) {
      this.currentStepTarget.textContent = data.current_step || ""
    }

    if (this.hasStepTextTarget) {
      this.stepTextTarget.textContent = `Step ${data.current_step_num} of ${data.total_steps}`
    }

    if (this.hasZipsCountTarget)   this.zipsCountTarget.textContent   = this.formatNumber(data.zips_updated)
    if (this.hasCitiesCountTarget) this.citiesCountTarget.textContent = this.formatNumber(data.cities_updated)
    if (this.hasMsasCountTarget)   this.msasCountTarget.textContent   = this.formatNumber(data.msas_updated)

    if (this.hasElapsedTextTarget && data.elapsed_seconds != null) {
      this.elapsedTextTarget.textContent = this.formatDuration(data.elapsed_seconds)
    }

    if (this.hasEtaTextTarget) {
      if (data.status === "completed") {
        this.etaTextTarget.textContent = "Done"
      } else if (data.eta_seconds != null && data.eta_seconds > 0) {
        this.etaTextTarget.textContent = `~${this.formatDuration(data.eta_seconds)} remaining`
      } else {
        this.etaTextTarget.textContent = "Calculating…"
      }
    }

    if (data.status === "failed" && data.error_log) {
      if (this.hasErrorBlockTarget) this.errorBlockTarget.hidden = false
      if (this.hasErrorTextTarget)  this.errorTextTarget.textContent = data.error_log
    }

    if (data.status === "completed" || data.status === "failed") {
      this.activeValue = false
      // Reload once so the completed/failed panel renders without animation.
      setTimeout(() => window.location.reload(), 800)
    }
  }

  capitalize(str) {
    if (!str) return ""
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  formatNumber(n) {
    if (n == null) return "0"
    return Number(n).toLocaleString()
  }

  formatDuration(totalSeconds) {
    if (totalSeconds == null) return "--"
    const h = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = Math.floor(totalSeconds % 60)
    if (h > 0) return `${h}h ${m}m ${s}s`
    if (m > 0) return `${m}m ${s}s`
    return `${s}s`
  }
}
